import type { Route } from '!/router'
import { Slot } from '!/router'
import { keys } from '~/shared/jail'
import { Footer } from '~/shared/ui/components/Footer'
import { NoContentBlock } from '~/shared/ui/components/NoContentBlock'
import { AccountSettingsModal } from '~/features/portal/redirect'
import * as pinLockFeature from '~/features/pin-lock'
import { NavBar } from '~/widgets/NavBar'
import { PartnerProgramGoPopup } from '~/widgets/PartnerProgram/PartnerProgramGoPopup'
import {
  AuthorizePaymentForm,
  ExternalPaymentOpen,
  GravyPaymentForm,
  NoPaymentForm,
} from '~/widgets/Payment'
import {
  AnnouncementPopup,
  InfoPopup,
  ProfilesCreatePopup,
  ProfilesRemovePopup,
} from '~/widgets/Popups'
import { SignInToWatchPopup } from '~/widgets/SignInToWatch'
import { PolicyMessage } from '~/features/policy-message'

import * as event from './event'
import * as live from './live'
import * as movie from './movie'
import * as partner from './partner'
import * as series from './series'

export const route: Route = {
  keys: [keys.app, keys.guest],

  component: [
    NavBar,
    Slot,
    GravyPaymentForm,
    AuthorizePaymentForm,
    NoPaymentForm,
    ExternalPaymentOpen,
    SignInToWatchPopup,
    pinLockFeature.PinLockPopup,
    NoContentBlock,
    Footer,
    InfoPopup,
    PartnerProgramGoPopup,
    ProfilesRemovePopup,
    ProfilesCreatePopup,
    AnnouncementPopup,
    AccountSettingsModal,
    PolicyMessage,
  ],

  children: [
    {
      path: '/event',
      load: event.route,
      // load: () => import('./event').then((m) => m.route),
    },
    {
      path: '/live',
      load: live.route,
      // load: () => import('./live').then((m) => m.route),
    },
    {
      path: '/movie',
      load: movie.route,
      // load: () => import('./movie').then((m) => m.route),
    },
    {
      path: '/partner',
      load: partner.route,
      // load: () => import('./partner').then((m) => m.route),
    },
    {
      path: '/series',
      load: series.route,
      // load: () => import('./series').then((m) => m.route),
    },
  ],
}
